import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-version-update',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.scss']
})
export class VersionUpdateComponent {

  constructor(public activeModal: NgbActiveModal) {}

  refreshPage() {
    // Clear any cached data and force hard refresh
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
        // Force hard refresh after service worker cleanup
        this.performHardRefresh();
      });
    } else {
      // Force hard refresh with cache bypass
      this.performHardRefresh();
    }
  }

  // Alternative method if the primary one doesn't work well
  refreshPageAlternative() {
    // Method using fetch to invalidate cache and then reload
    this.invalidateCacheAndReload();
  }

  private performHardRefresh() {
    // Clear only resource caches (JS/CSS/etc.) but preserve user session data
    this.clearBrowserCaches().then(() => {
      // Use cache-busting parameter to force fresh resource loading
      const timestamp = new Date().getTime();
      const currentUrl = window.location.href.split('?')[0].split('#')[0];
      window.location.href = currentUrl + '?v=' + timestamp;
    });
  }

  private async clearBrowserCaches(): Promise<void> {
    try {
      // Only clear Cache API (for cached resources like JS/CSS files)
      // DO NOT clear localStorage/sessionStorage to preserve user session
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
      }

      // Note: We intentionally DO NOT clear localStorage/sessionStorage
      // to preserve user session and authentication data

    } catch (error) {
      console.warn('Could not clear resource caches:', error);
    }
  }

  private async invalidateCacheAndReload(): Promise<void> {
    try {
      // Fetch the current page with cache-busting headers to get fresh resources
      await fetch(window.location.href, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      
      // Clear only resource caches (preserve user session)
      await this.clearBrowserCaches();
      
      // Reload with cache-busting parameter
      const timestamp = new Date().getTime();
      const currentUrl = window.location.href.split('?')[0].split('#')[0];
      window.location.href = currentUrl + '?v=' + timestamp;
      
    } catch (error) {
      console.warn('Cache invalidation failed, falling back to simple reload:', error);
      // Fallback to simple reload with timestamp
      const timestamp = new Date().getTime();
      const currentUrl = window.location.href.split('?')[0].split('#')[0];
      window.location.href = currentUrl + '?v=' + timestamp;
    }
  }

  dismissModal() {
    this.activeModal.dismiss('later');
  }
}
